// Admin: create logins, set roles, reset passwords, deactivate.
import { listProfiles, updateProfile, adminUsers } from '../lib/api.js';
import { $, $$, esc, busy, toast } from '../lib/ui.js';

export async function renderUsers(app, { profile: me }) {
  app.innerHTML = '<div class="full" id="box"><p class="pad">Loading…</p></div>';
  const box = $('#box');

  async function load() {
    let people;
    try { people = await listProfiles(); } catch (e) { box.innerHTML = `<div class="err">${esc(e.message)}</div>`; return; }
    box.innerHTML = `
      <div class="card">
        <h3>Add a user</h3>
        <form class="form" id="add" style="padding:10px 0 0">
          <input id="fn" placeholder="Full name" required>
          <input id="em" type="email" placeholder="Email (used to sign in)" required>
          <input id="ph" placeholder="Phone (optional)">
          <select id="rl"><option value="driver">Driver</option><option value="dispatcher">Dispatcher</option><option value="admin">Admin</option></select>
          <input id="pw" placeholder="Temporary password (8+ characters)" minlength="8" required>
          <button class="primary" type="submit">Create login</button>
        </form>
      </div>
      <div class="card" style="padding:0;overflow-x:auto">
        <table class="list"><thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th></th></tr></thead><tbody>
        ${people.map(p => `<tr>
          <td>${esc(p.full_name || '—')}<div class="addr">${esc(p.phone || '')}</div></td>
          <td>${esc(p.email || '—')}</td>
          <td><select data-role="${p.id}" ${p.id === me.id ? 'disabled' : ''}>
            ${['driver', 'dispatcher', 'admin'].map(r => `<option ${r === p.role ? 'selected' : ''}>${r}</option>`).join('')}
          </select></td>
          <td>${p.active ? 'active' : '<b style="color:#b91c1c">inactive</b>'}</td>
          <td style="white-space:nowrap"><button data-pw="${p.id}">Reset password</button>
            ${p.id === me.id ? '' : `<button class="${p.active ? 'warn' : ''}" data-act="${p.id}" data-on="${p.active ? 0 : 1}">${p.active ? 'Deactivate' : 'Activate'}</button>`}</td>
        </tr>`).join('')}
        </tbody></table>
      </div>`;
    $('#add').onsubmit = e => {
      e.preventDefault();
      busy(e.submitter, async () => {
        await adminUsers({ action: 'create', full_name: $('#fn').value.trim(), email: $('#em').value.trim(), phone: $('#ph').value.trim(), role: $('#rl').value, password: $('#pw').value });
        toast('User created. Share the email + temporary password with them.');
        await load();
      }).catch(() => {});
    };
    $$('[data-role]', box).forEach(s => s.onchange = () => busy(null, async () => { await updateProfile(s.dataset.role, { role: s.value }); toast('Role updated.'); }).catch(() => load()));
    $$('[data-pw]', box).forEach(b => b.onclick = () => {
      const pw = prompt('New password (8+ characters):');
      if (pw) busy(b, async () => { await adminUsers({ action: 'set_password', user_id: b.dataset.pw, password: pw }); toast('Password changed.'); }).catch(() => {});
    });
    $$('[data-act]', box).forEach(b => b.onclick = () => busy(b, async () => {
      await adminUsers({ action: 'set_active', user_id: b.dataset.act, active: b.dataset.on === '1' }); await load();
    }).catch(() => {}));
  }

  await load();
}
